<template>
  <div>

    <v-card class="rounded-lg shadow">
      <v-overlay :value="overlay" absolute color="white" opacity="0.5">
        <v-progress-circular
            color="primary"
            indeterminate
            size="50"
        ></v-progress-circular>
      </v-overlay>

      <v-card-title>

        <div>
          <v-text-field
              v-model="keyword"
              append-icon="mdi-magnify"
              @keydown.enter="getData"
              hint="Appuyez sur ↵ Entrée pour rechercher"
              clearable
              @click:clear="[keyword=null,getData()]"
              dense
              filled
              persistent-hint
              placeholder="GIFT-XXXXXX"
              rounded
          ></v-text-field>
        </div>
        &nbsp;
        <div>
          <v-autocomplete :items="batchs"
                          placeholder="Lot-XXXXXX"
                          item-text="note"
                          item-value="id"
                          @change="getData"
                          v-model="delivery_refill_campaign_id"
                          hint="Filtrer par lot"
                          clearable
                          dense
                          filled
                          persistent-hint
                          rounded
          ></v-autocomplete>
        </div>

        <v-spacer/>

        <v-btn color="grey"
               text
               @click="getData">
          <v-icon left>mdi-refresh</v-icon>
          Mettre à jour
        </v-btn>

        <v-btn color="grey"
               text
        >
          <v-icon left>mdi-filter-outline</v-icon>
          Filtrer
        </v-btn>

        <v-btn color="gifty"
               text
               :loading="printLoading"
               @click="handlePrint(null)"
               :disabled="!selected.length"
               class="v-btn--active white--text mr-1"
        >
          <v-icon left>mdi-printer</v-icon>
          Imprimer
        </v-btn>
      </v-card-title>

      <v-divider/>

      <v-card-text v-if="isLoading">
        <v-skeleton-loader type="table"/>
      </v-card-text>

      <div v-else>
        <v-card-text>
          <v-simple-table class="table-border rounded-lg" v-if="cards.length">
            <template v-slot:default>
              <thead>
              <tr>
                <th>
                  <v-checkbox class="pa-0 ma-0"
                              hide-details
                              color="success"
                              :input-value="allSelected"
                              :indeterminate="isIndeterminate"
                              @click="toggleSelectAll"
                  />
                </th>
                <th>Lot</th>
                <th>Code</th>
                <th>Montant</th>
                <th>Expiré le</th>
                <th>Réservée</th>
                <th>Actions</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item ,index) in cards" :key="index">

                <td>
                  <v-checkbox hide-details
                              color="success"
                              :value="item.id"
                              class="pa-0 ma-0"
                              v-model="selected"/>
                </td>

                <td>
                  {{ item.delivery_refill_campaign.note }}
                </td>

                <td class="font-weight-bold">
                  {{ item.voucher.code }}
                </td>


                <td class="font-weight-medium">
                  {{ CurrencyFormatting(item.voucher.amount) }}
                </td>

                <td class="font-weight-medium">
                  {{ item.delivery_refill_campaign.expiry_date }}
                </td>

                <td>
                  <v-icon v-if="item.reserved" color="success">mdi-check-circle</v-icon>
                  <v-icon v-else color="grey lighten-1">mdi-timer-sand</v-icon>
                </td>

                <td>
                  <div class="d-flex align-center">
                    <v-btn icon color="gifty"
                           :loading="loadingPrint[item.id]"
                           @click="handlePrint(item.id)">
                      <v-icon>mdi-printer</v-icon>
                    </v-btn>
                  </div>
                </td>

              </tr>
              </tbody>
            </template>
          </v-simple-table>

          <div v-else>
            <NoResults @reload="getData"/>
          </div>

        </v-card-text>
        <v-divider/>

        <v-card-actions>

          <div :style="{width: '120px'}">
            <v-select v-model="perPage"
                      :items="[10,20,30,50,100]"
                      dense
                      hide-details
                      label="Ligne par page"
                      outlined></v-select>
          </div>

          <v-spacer/>


          <small class="text--darken-2 grey--text">
            {{ pageStart }}-{{ pageEnd }} de {{ total }}
          </small>
          <v-pagination v-model="pagination.current"
                        :length="pagination.total"
                        circle
                        total-visible="8"
                        @input="getData"></v-pagination>

        </v-card-actions>

      </div>
    </v-card>
  </div>
</template>

<script>
import {HTTP} from "@/http-common";
import NoResults from "@/components/NoResults.vue";

export default {
  components: {NoResults},
  data() {
    return {
      keyword: null,
      loadingPrint: {},
      loadingStatus: {},
      batchs: [],
      delivery_refill_campaign_id: null,
      selected: [],
      printLoading: false,
      isLoading: false,
      overlay: false,
      cards: [],
      total: 0,
      perPage: 10,
      pagination: {
        current: 1,
        total: 0
      },
    };
  },
  methods: {
    toggleSelectAll() {
      if (this.allSelected) {
        this.selected = [];
      } else {
        this.selected = this.cards.map(card => card.id);
      }
    },
    statusColor(status) {
      switch (status) {
        case "created":
          return "blue lighten-2";
        case "shipped":
          return "orange lighten-2";
        case "delivered":
          return "green lighten-2";
        case "printed":
          return "red lighten-2";
        case "used":
          return "gifty lighten-2";
        default:
          return "grey lighten-2";
      }
    },
    getData() {
      this.isLoading = true
      HTTP.get('/v1/refill-card-delivery/cards?page=' + this.pagination.current, {
        params: {
          perPage: this.perPage,
          keyword: this.keyword,
          delivery_refill_campaign_id: this.delivery_refill_campaign_id,
        }
      }).then(res => {

        this.pagination.current = res.data.data.current_page;
        this.pagination.total = res.data.data.last_page;
        this.total = res.data.data.total;

        this.cards = res.data.data.data

        this.isLoading = false
      }).catch(err => {
        this.isLoading = false
        console.log(err)
      })
    },
    getBatchs() {
      HTTP.get('/v1/refill-card-delivery/all').then(res => {
        this.batchs = res.data.data
      }).catch(err => {
        console.log(err)
      })
    },
    handlePrint(id = null) {
      let ids = [];

      if (id) {
        ids = [id];
        this.$set(this.loadingPrint, id, true);
      } else {
        ids = this.selected;
        this.printLoading = true
      }

      HTTP.get(`/v1/refill-card-delivery/print-card?ids=${ids}`, {responseType: 'blob'})
          .then(res => {
            const blob = new Blob([res.data], {type: 'application/pdf'});
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = 'refill-cards.pdf';
            link.click();
            URL.revokeObjectURL(link.href);
          })
          .catch(err => {
            this.$errorMessage = "Server Error!";
            console.log(err);
          })
          .finally(() => {
            if (id) {
              this.loadingPrint[id] = false;
            } else {
              this.printLoading = false
            }
          });
    },
  },
  computed: {
    pageStart() {
      if (this.total === 0) return 0
      return (this.pagination.current - 1) * this.perPage + 1
    },
    pageEnd() {
      let end = this.pagination.current * this.perPage
      return end > this.total ? this.total : end
    },
    allSelected() {
      return this.selected.length === this.cards.length && this.cards.length > 0;
    },
    isIndeterminate() {
      return this.selected.length > 0 && this.selected.length < this.cards.length;
    }
  },
  watch: {
    $is_confirm: function (el) {
      if (el) {
        this.deleteItem();
        this.$is_confirm = false;
      }
    },
    perPage() {
      this.pagination.current = 1
      this.getData();
    },
  },
  created() {
    this.getBatchs();
    this.getData();
  },
};
</script>

<style scoped>

</style>